import { render, staticRenderFns } from "./PatientDetailPage.vue?vue&type=template&id=da90829a"
import script from "./PatientDetailPage.vue?vue&type=script&lang=js"
export * from "./PatientDetailPage.vue?vue&type=script&lang=js"
import style0 from "./PatientDetailPage.vue?vue&type=style&index=0&id=da90829a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports